import * as React from 'react';

export interface WithUnsavedChangesProps {
  hasUnsavedChanges: boolean;
  setUnsavedChanges: (value: boolean) => void;
}

/**
 * This is just a placeholder for context value which will be assigned within provider component
 */
const defaultValue: WithUnsavedChangesProps = {
  hasUnsavedChanges: false,
  setUnsavedChanges: () => false,
};

const context = React.createContext(defaultValue);
export default context;
